import React from "react";
import { useSelector } from "react-redux";
import Text from "../text/Text";
import classes from './Tag.module.css'

const Tag = ({ name, dropClass }) => {
    const tags = useSelector(state => state.uiData.tags);

    const tag = tags && tags.find(t => t.name === name);
    return (
        <>
            {tag &&
                <div className={`${classes.Tag} ${dropClass}`} style={{ backgroundColor: tag.color }}>
                    <Text>{tag.text}</Text>
                </div>
            }
        </>
    )
}

export default Tag;